import { Button, ButtonLink } from "@/components/Buttons/index";
import routes from "@/lib/routes";
import { useRouter } from "next/router";
import loginStyles from "@/styles/Login.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { useModal } from "@/hooks";
import IdcCooperationSignUpModal from "../IdcCooperationSignupModal";
import { useCallback } from "react";

// ログイン画面3
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SpooxCooperationForm(props) {
  const router = useRouter();
  const {
    showModal,
    hideModal
  } = useModal();
  const onClickHandle = useCallback(() => {
    hideModal();
    router.push(routes.signUp);
  }, []);
  const showSignupModal = useCallback(() => {
    showModal( /*#__PURE__*/_jsx(IdcCooperationSignUpModal, {
      onClickHandle: onClickHandle
    }), {
      closeButton: true,
      outerAreaClose: true,
      style: "signup"
    });
  }, [onClickHandle]);
  return /*#__PURE__*/_jsxs("div", {
    className: `${processStyles.content} ${loginStyles.loginSet}`,
    children: [/*#__PURE__*/_jsxs("div", {
      className: `${loginStyles.loginSection} ${loginStyles.formSection}`,
      children: [/*#__PURE__*/_jsx("h3", {
        className: loginStyles.sectionTitle,
        children: "SPOOX ID\u3092\u304A\u6301\u3061\u306E\u65B9"
      }), /*#__PURE__*/_jsxs("div", {
        className: loginStyles.sectionInner,
        children: [/*#__PURE__*/_jsx("div", {
          className: loginStyles.loginBtnArea,
          children: /*#__PURE__*/_jsx(ButtonLink, {
            href: routes.loginspoox,
            fillMainColor: true,
            large: true,
            fontFixed: true,
            fontBold: true,
            disabled: props.error,
            children: "SPOOX ID\u3068\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u3092\u9023\u643A"
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: loginStyles.caption,
          children: ["\u203B\u73FE\u5728\u3054\u5951\u7D04\u4E2D\u306E\u5546\u54C1\u53CA\u3073\u767B\u9332\u6E08\u307F\u652F\u6255\u65B9\u6CD5\u306E\u7D99\u7D9A\u5229\u7528\u306B\u306F\u3001", /*#__PURE__*/_jsx("br", {}), "SPOOX ID\u3068\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u306E\u9023\u643A\u304C\u5FC5\u8981\u3067\u3059\u3002", /*#__PURE__*/_jsx("br", {}), "\u5FC5\u305A\u9023\u643A\u3055\u305B\u3066\u304F\u3060\u3055\u3044\u3002"]
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: `${loginStyles.loginSection} ${loginStyles.formSection}`,
      children: [/*#__PURE__*/_jsx("h3", {
        className: loginStyles.sectionTitle,
        children: "SPOOX\u3092\u521D\u3081\u3066\u3054\u5229\u7528\u3055\u308C\u308B\u65B9"
      }), /*#__PURE__*/_jsx("div", {
        className: loginStyles.sectionInner,
        children: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(Button, {
            onClick: showSignupModal,
            fillMainColor: true,
            large: true,
            fontFixed: true,
            fontBold: true,
            disabled: props.error,
            children: "SPOOX\u5229\u7528\u767B\u9332"
          })
        })
      })]
    })]
  });
}